<template>
  <div>
      <h2>成绩查询</h2>
      <a-divider></a-divider>
      <!-- <iframe width="100%" height="800px" src="/cert/score.html" frameborder="no"></iframe> -->
      <ScoreQuery/>
  </div>
</template>

<script>
import ScoreQuery from '../ScoreQuery'
export default {
  components:{
    ScoreQuery
  }
}
</script>

<style>

</style>